import axios, { AxiosResponse } from 'axios';
import { FetchBestViewd } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
export const getBestViewdApi = async ({
  sortType,
  UserId,
  currentPage,
  type,
}: FetchBestViewd) => {
  const responseBody = (response: AxiosResponse) => response.data;
  const user_id = localStorage.getItem('user_id');
  const apiEndpoint =
    GET_BASE_URL + '/api/v1/bestoftheday?type=' + type + `&user_id=${user_id}`;

  if (type === 'w') {
    localStorage.setItem('pagename', 'Best of the Week');
  } else if (type === 'm') {
    localStorage.setItem('pagename', 'Best of the Month');
  } else if (type === '12m') {
    localStorage.setItem('pagename', 'Best of the Past 12 Months');
  } else if (/^\d{4}$/.test(String(type))) {
    localStorage.setItem('pagename', `Best of ${type}`);
  } else {
    localStorage.setItem('pagename', 'Best of the Day');
  }

  const { data } = await axios
    .get<Lounge[]>(`${apiEndpoint}`)
    .then(responseBody);

  return data;
};
